<template>
    <div class="flex flex-col justify-center md:justify-start
            my-auto pt-8 md:pt-0 px-8 md:px-24 lg:px-4">
        <div class="flex justify-between w-full justify-center md:px-2">
            <p class="text-left py-8 text-green-700 text-xl font-semibold">
                Présentation du calculateur carbone
            </p>
        </div>
        <div class="flex justify-between w-full justify-center md:px-3 md:py-3
         text-white rounded-sm"
         style="background-color: #008a88">
            <div>
                <p class="w-full">
                    Le <b>calculateur carbone</b> ci-contre vous permet de
                     <b>déterminer rapidement
                    les indicateurs "carbone" relatifs à la transformation du bois de France</b>
                    que vous utilisez dans votre projet.
                </p><br/>
                <p class="w-full">
                    Utilisez les champs de saisie <b>"Volume"</b> et <b>"Essence"</b> pour
                     indiquer la quantité et
                    l'essence de bois retenue pour votre projet, afin
                     <b>d'afficher automatiquement</b>
                    les résultats suivants :
                </p>
                <ul>
                    <li>- <b>Emissions nettes de gaz à effet de serre</b>
                         (en kg équivalents CO&#8322;)</li>
                    <li>- <b>Quelques chiffres représentant l'économie carbone réalisée</b></li>
                    <li>- <b>Un comparatif carbone avec d'autres matériaux courants</b></li>
                </ul>
                <br/>
                <p class="w-full">
                    Il existe <b>une relation directe entre la quantité de carbone biogénique
                     stockée dans le bois, et la quantité de dioxyde de carbone captée par
                      photosynthèse lors de la croissance de l'arbre.</b> Pour convertir carbone
                       en dioxyde de carbone, il faut multiplier par 3,67. Pour convertir
                        dioxyde de carbone en carbone, il faut multiplier par 0,273.
                </p>
                <br/>
                <p class="w-full">
                    Les indicateurs "carbone" relatifs à la transformation du bois et des
                     autres matériaux courants de construction sont déterminés sur la
                      base méthodologique de la norme NF EN 15804+A1 "Contribution des
                       ouvrages de construction au développement durable - Déclarations
                        environnementales sur les produits - Règles régissant les catégories
                         de produits de construction", notamment via les Fiches de
                          Déclaration Environnementales et Sanitaires (FDES) de ces matériaux.
                </p>
                <br/>
                <p class="w-full">
                    En particulier les émissions nettes de gaz à effet de serre des produits
                     bois sont calculées comme la différence entre 1/ les émissions de gaz
                      à effet de serre pour la transformation des bois, et 2/ la captation de
                       dioxyde de carbone par la photosynthèse lors de la croissance des
                        arbres (comptabilisation calculée suivant NF EN 16449 et NF EN 16485).
                </p>
                <br/>
                <p class="w-full">
                    * Note : les graphes ci-contre ont une vocation pédagogique et ne remplacent
                     pas une analyse de cycle de vie complète d'un bâtiment
                </p>
                <br/>
                <h3 class="font-bold">En savoir plus</h3>
                <br/>
                <div class="flex flex-wrap -mx-3 mb-1">
                    <div class="w-full md:w-1/3 px-3">
                        <a class="shadow-2xl" href="https://www.fnbois.com/wp-content/uploads/2019/11/FNB-La-for%c3%aat-fran%c3%a7aise-et-les-produits-en-Bois-Fran%c3%a7ais-partenaires-de-la-construction-bas-carbone.pdf" target="_blank">
                            <img src="/icons/Image_plaquette.png" class="w-auto shadow-2xl">
                        </a>
                    </div>
                    <div class="w-full md:w-2/3 px-3">
                        <a class="shadow-2xl" href="https://www.fnbois.com/wp-content/uploads/2019/11/FNB-La-for%c3%aat-fran%c3%a7aise-et-les-produits-en-Bois-Fran%c3%a7ais-partenaires-de-la-construction-bas-carbone.pdf" target="_blank">
                            <p class="w-full">
                            Plaquette "La forêt française & les produits en bois français
                            partenaires de la construction bas carbone"
                            </p>
                        </a>
                    </div>
                </div>
                <br/>
                <div class="flex flex-wrap -mx-3 mb-1">
                    <div class="w-full md:w-1/3 px-3">
                    <a class="shadow-2xl" href="https://www.fnbois.com/wp-content/uploads/2020/07/Bois-de-France-Note-m%C3%A9thodologique-calculateur-carbone-v1.1.pdf" target="_blank">
                        <img src="/icons/Image_note_methodologique.png" class="w-auto shadow-2xl">
                    </a>
                    </div>
                    <div class="w-full md:w-2/3 px-3">
                        <a href="https://www.fnbois.com/wp-content/uploads/2020/07/Bois-de-France-Note-m%C3%A9thodologique-calculateur-carbone-v1.1.pdf" target="_blank">
                            <p class="w-full">
                            Méthodologie utilisée pour la réalisation du calculateur
                            </p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
};

</script>
